import { useEffect } from 'react';

export const useTouchScroll = (
  wrapperScroll,
  avanzar = () => {},
  retroceder = () => {},
  stopAutoPlay = () => {},
  startAutoPlay = () => {},
  refCard = null,
  idCard,
) => {
  let x1;
  let x2;

  const handleTouchstart = e => {
    e.preventDefault();
    let touchObj = e.changedTouches?.[0];
    x1 = parseInt(touchObj.clientX);
  };

  const handleTouchend = e => {
    e.preventDefault();
    stopAutoPlay();
    const width = wrapperScroll.current?.offsetWidth;
    let touchobj = e.changedTouches?.[0];
    x2 = parseInt(touchobj.clientX);

    let difference = x2 - x1;
    let result = (width * difference) / 100;

    if(x1 === x2){
      if(refCard?.current && idCard?.current){
        refCard?.current?.[idCard?.current]?.click();
        return;
      }
    }

    if (result > 20) {
      retroceder();
    } else if (result < -20) {
      avanzar();
    }

    startAutoPlay();
  };

  const initTouchEvents = () => {
    wrapperScroll.current.addEventListener('touchstart', handleTouchstart);
    wrapperScroll.current.addEventListener('touchend', handleTouchend);
  };

  useEffect(() => {
    if (wrapperScroll?.current) {
      initTouchEvents();
    }

    return () => {
      if (wrapperScroll?.current) {
        wrapperScroll.current.removeEventListener(
          'touchstart',
          handleTouchstart,
        );
        wrapperScroll.current.removeEventListener(
          'touchstart',
          handleTouchstart,
        );
      }
    };
  }, []);
};
